export { THEME } from './theme-legacy';
